import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  label: {
    ...theme.typography.subtitle2,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.grey['400'],
    fontSize: 14,
    lineHeight: '18px',
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  progress: {
    marginLeft: 8,
    width: 310,
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.palette.grey['300']
  }
}));

const LinearProgressWithStatus = (props) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.label}>{props.status}</Typography>
      <LinearProgress className={classes.progress} variant="determinate" {...props} />
      <Typography className={classes.label}>{`${Math.round(props.value)}%`}</Typography>
    </Box>
  );
}

export default LinearProgressWithStatus;